var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"mb-5",attrs:{"show-select":"","headers":_vm.headers,"items":_vm.lineItems,"item-key":"name"}})}
var staticRenderFns = []

export { render, staticRenderFns }